import { cloneDeep } from 'lodash';
import { useParsedProducts } from '../../components/hooks/useParsedProducts/index.js';
import { COVIDINSURANCE, INSURANCE, SUSTAINABILITY } from '../../components/models.js';
export const usePriceOverviewData = ({
  products,
  journey,
  organizerDiscount,
  paymentInfo
}) => {
  const parsedProducts = useParsedProducts(products);
  const journeyPrice = organizerDiscount ? {
    price: {
      ...journey.price,
      value: journey.price.value - organizerDiscount.price.value
    },
    displayPrice: {
      ...journey.displayPrice,
      value: journey.displayPrice.value - organizerDiscount.displayPrice.value
    }
  } : {
    price: journey.price,
    displayPrice: journey.displayPrice
  };
  const travelPrice = cloneDeep(journeyPrice);
  const totalPrice = cloneDeep(journeyPrice);
  for (const p of parsedProducts) {
    if (!p.type?.includes('Included')) {
      totalPrice.price.value += p.price.value;
      totalPrice.displayPrice.value += p.displayPrice.value;
    }
  }
  const insuranceProducts = parsedProducts.filter(product => product.type === INSURANCE || product.type === COVIDINSURANCE).sort((a, b) => {
    if (a.type === INSURANCE && b.type !== INSURANCE) {
      return -1;
    } else if (a.type !== INSURANCE && b.type === INSURANCE) {
      return 1;
    } else {
      return 0;
    }
  });
  const miscellaneousProducts = parsedProducts.filter(product => product.type === SUSTAINABILITY);
  const flexProducts = parsedProducts.filter(product => product.type !== INSURANCE && product.type !== COVIDINSURANCE && product.type !== SUSTAINABILITY);
  let excludedFlexOption = false;
  for (const p of flexProducts) {
    if (p.type?.includes('Excluded')) {
      travelPrice.price.value += p.price.value;
      travelPrice.displayPrice.value += p.displayPrice.value;
      excludedFlexOption = true;
    }
  }
  const updatedPaymentInfo = typeof paymentInfo === 'string' ? paymentInfo : {
    ...paymentInfo,
    final: {
      displayPrice: {
        ...paymentInfo.final.displayPrice,
        value: paymentInfo.final.displayPrice.value - paymentInfo.finalDiscount + (excludedFlexOption ? paymentInfo.finalFee : 0)
      },
      price: {
        ...paymentInfo.final.price,
        value: paymentInfo.final.price.value - paymentInfo.finalDiscount + (excludedFlexOption ? paymentInfo.finalFee : 0)
      }
    },
    deposit: paymentInfo.deposit ? {
      ...paymentInfo.deposit,
      price: {
        ...paymentInfo.deposit.price,
        value: paymentInfo.deposit.price.value - paymentInfo.depositDiscount + (excludedFlexOption ? paymentInfo.depositFee : 0)
      },
      displayPrice: {
        ...paymentInfo.deposit.displayPrice,
        value: paymentInfo.deposit.displayPrice.value - paymentInfo.depositDiscount + (excludedFlexOption ? paymentInfo.depositFee : 0)
      }
    } : null,
    depositDue: paymentInfo.depositDue || null,
    finalDue: paymentInfo.finalDue || null
  };
  return {
    travelPrice,
    totalPrice,
    insuranceProducts,
    miscellaneousProducts,
    flexProducts,
    updatedPaymentInfo
  };
};